<template>
	<div
		id="docType-management"
		:class="[!isWeb ? 'mobile-docType-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="docType-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<DocTypeTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_DOC_TYPES } from '@/store/modules/docTypeManagement/actions';
import TableFilter from '@/components/modules/DocType/DocTypeManagement/TableFilter/TableFilter.vue';
import DocTypeTable from '@/components/modules/DocType/DocTypeManagement/Table/Table.vue';

export default {
	name: 'DocTypeManagement',
	components: { TableFilter, DocTypeTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshDocType();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('docTypeManagement', {
			getDocsTypes: GET_ALL_DOC_TYPES,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshDocType();
		},
		searchFromInput(params) {
			this.searchParams = params;
			this.page = 1;
			this.refreshDocType();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshDocType();
		},
		refreshDocType() {
			let params = `?limit=20&page=${this.page}`;
			if (this.searchParams) params += `&search=${this.searchParams}`;
			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getDocsTypes({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'DocTypeManagement.scss';
</style>
